import React, { useState, useMemo,Fragment } from 'react'
import {
    List, Datagrid, Filter, ShowButton, UrlField, Button, TextInput,TextField, EditButton,TopToolbar, BulkDeleteButton, useListContext, FunctionField, DeleteButton, useRecordContext, Link, SimpleForm, useRefresh, SelectInput, required, FormDataConsumer, useNotify, SaveButton, Toolbar
} from 'react-admin'
import { InfluencerStatusSelectInput, AdminUserSelectInput, ViewSelectInput } from '../../UI/Input/SelectInput'
import DownloadIcon from '@material-ui/icons/GetApp';
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'
import { DateRangeInput } from '../../UI/Input/input';
import Grid from "@material-ui/core/Grid";
import IconCancel from "@material-ui/icons/Cancel";
import { actionOfContentReview } from '../../Model/actionOfContentReview';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import BulkActiveButton from '../NewTasks/Action/Bulk.Active.Button';
import { stringify } from 'query-string';
const ListFilter = (props) => {
    const {

        setFilters,
        hideFilter
    } = useListContext();
    return (

        <Filter {...props}>
            <TextInput label="Search" source="q" alwaysOn />
            <ViewSelectInput label="View" source="view" alwaysOn />
            <InfluencerStatusSelectInput label="Status" source="status" alwaysOn />
            <AdminUserSelectInput label="Admin User" source="adminuser" alwaysOn />
            <DateRangeInput alwaysOn onClear={() => { hideFilter('daterange') }} onChange={(strdate) => {
                setFilters({ daterange: strdate })
            }} />
        </Filter>
    )
};

const ProfileidFiled = (props) => {
    const record = useRecordContext();
    return (
        <TextField {...props} component={Link} to={`/user?filter={"q":"${record.profile_id}"}`} onClick={(event) => event.stopPropagation()} />
    )
}

const SanitizedGrid = ({ basePath, ...props }) => {
    return <Grid {...props} />;
};
const FormToolbar = props => (
    <Toolbar {...props} >
        <SaveButton label="Submit" redirect={null} submitonenter={false} />
        {!props.saving && <Button label="ra.action.cancel" onClick={props.onCancel}>
            <IconCancel />
        </Button>}
    </Toolbar>
)

const ListActions = (props) => {
  const record = useListContext();
  const filva = record.filterValues ? stringify(record.filterValues) : '';
  return (<TopToolbar>
    <Button href={`//sboportal.org.in/admin/api/v1/contentreview/export?${filva}`} label="Export Data" ><DownloadIcon /></Button>
  </TopToolbar>)
}

const BulkActionButtons = ({  ...props }) => {

  return (<Fragment>
      <BulkActiveButton label="Bulck Active"  {...props} />
  </Fragment>)
}


const ContentReviewList = ({ ...props }) => {
    const [open, setOpen] = useState(false);
    const refresh = useRefresh()
    const notify = useNotify()
    const recordold = useRecordContext();
    // const {onClose, record } = this.props
    const [inputValue, setInputValue] = useState('');
    const [selectedId, setSelectedId] = useState(null);
    const [recordStatus, setRecordStatus] = useState(null);

    const handleOpenDialog = (record) => {
        console.log(record);
        console.log('record');
        setSelectedId(record.id);
        setRecordStatus(record.status);
        setOpen(true);
    }
    const handleCloseDialog = () => setOpen(false);


    // // Function to handle submit action in the dialog
    const handleSubmitNew = (record) => {

        const data = {
            "rid": selectedId,
            "status": record.status,
            "reason": record.decline_reason
        }
        actionOfContentReview(data, selectedId, (res) => {
            refresh()
            notify(res.message)
             refresh()
        }, (res) => {
            notify(res.message, 'warning')
        })
        
        setOpen(false);

    };

    const OpenDialogButton = ({ onClick }) => {
        const record = useRecordContext(); // Access the current record context
        if (!record) return null; // Ensure record exists
        return (

           <Button
    style={{ color: 'purple', border: '1px solid' }}
    label="Update Action"
    size="small"
    onClick={(event) => {
        event.stopPropagation();
        onClick(record);
    }}
/>
        );
    };


    const choices = useMemo(() => {

        if (recordStatus === 'Pending') {
            return [
                { id: 'Approved', name: 'Approved' },
                { id: 'Reject', name: 'Reject' },
            ];
        } else if (recordStatus === 'Approved') {
            return [
                { id: 'Pending', name: 'Pending' },
                { id: 'Reject', name: 'Reject' },
            ];
        } else {
            return [
                { id: 'Pending', name: 'Pending' },
                { id: 'Approved', name: 'Approved' },
            ];
        }
    }, [recordStatus]);

    return (
          <Fragment>
        <List 
        {...props} 
        title="Content Review"
       
      
        filters={<ListFilter />} 
          filter={{ uid: -1 }} 
        sort={{ field: 'title', order: 'ASC' }}>

            <Datagrid   rowClick={false}
    bulkActionButtons={<BulkActionButtons />}>
                {useCheckPermissions('ContentReviewer_Edit') ? <OpenDialogButton onClick={handleOpenDialog} /> : null}
                <TextField source="id" />
                <ProfileidFiled source="profile_id" label="Profile Id" />
                <TextField source='name' label="name" />

                <TextField source="rating" label="Rating" />
                <TextField source="task_amount" label="Task Amount" />
                <TextField source="contentreviewerquestionone" label="Content Review Question One" />
                <TextField source="contentreviewerquestiontwo" label="Content Review Question Two" />
                <TextField source="contentreviewerquestionthree" label="Content Review Question Three" />

                <TextField source="contentreviewerquestioninputone" label="Content Review Question Input One" />
                <TextField source="contentreviewerquestioninputtwo" label="Content Review Question Input Two" />
                <TextField source="contentreviewerquestioninputthree" label="Content Review Question Input Three" />

                <TextField source='created_at' label="Created At" />
                <TextField source="decline_reason" label="Decline Reason" />
                {/* <TextField source="deduction_amount" label="Deduction Amount" /> */}
                <FunctionField source="status" label="Status" render={record => {
                    if (record['status'] === 'Reject') {
                        return (<span style={{ color: 'red' }}>Reject</span>)
                    } else if (record['status'] === 'Pending') {
                        return (<span style={{ color: 'orange' }}>Pending</span>)
                    } else {
                        return (<span style={{ color: 'green' }}>Approved</span>)
                    }
                }} />

                {/* <TextField source="approvedby.name" label="Approved By" /> */}
                <TextField source="assignedby.name" label="Assigned By" />
                <TextField source="assignee.name" label="Assignee" />
                <TextField source="rejactedby.name" label="Rejacted By" />
                <TextField source="assigned_at" label="Assigned Date" />
                <TextField source="approved_at" label="Approved Date" />
                <TextField source="rejected_at" label="Rejected Date" />

                {useCheckPermissions('ContentReviewer_Edit') ? <EditButton /> : null}

            </Datagrid>
            <Dialog maxWidth='900px' open={open} onClose={handleCloseDialog}>
                <DialogTitle> Record Id - {recordStatus}</DialogTitle>

                <SimpleForm sx={{ minWidth: '400px', }} onSubmit={(record) => handleSubmitNew(record)} toolbar={<FormToolbar onCancel={() => { handleCloseDialog() }} />} >
                    <SanitizedGrid container spacing={3} fullWidth>

                        {<Grid item sm={12} lg={12}>
                            <InfluencerStatusSelectInput validate={required()} source="status" label="Status" fullWidth choices={choices}{...props} />

                        </Grid>}
                        <Grid item sm={12} lg={12}>
                            <FormDataConsumer>
                                {({ formData, ...rest }) =>
                                    formData.status === "Reject" && (
                                        <TextInput source="decline_reason" label="Reason" fullWidth resettable multiline validate={required()} />
                                    )
                                }
                            </FormDataConsumer>

                        </Grid>
                    </SanitizedGrid>
                </SimpleForm>


            </Dialog>
        </List>
        </Fragment>
    )
}


export default ContentReviewList